import React from 'react';
import cx from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import { getTrancatableText } from './helpers';
import { WorkspaceCardFooterFieldProps } from './WorkspaceCardFooterField.type';
import classes from './WorkspaceCardFooterField.module.scss';

const WorkspaceCardFooterField: React.FC<WorkspaceCardFooterFieldProps> = ({
  isTruncatable = true,
  shouldTextTruncate = false,
  isMaxShrinkable,
  label,
  value,
  dataMaskTest
}) => {
  return (
    <div
      className={cx(classes.field, {
        [classes.truncatable]: isTruncatable,
        [classes.maxShrink]: isMaxShrinkable
      })}
    >
      <span className={cx(classes.fieldText, classes.fieldLabel)}>{label}</span>
      <Tooltip arrow placement="top" title={value}>
        <span
          className={cx(classes.fieldText, classes.fieldValue)}
          data-mask-test={dataMaskTest}
        >
          {isTruncatable
            ? getTrancatableText(value.toString(), shouldTextTruncate)
            : value}
        </span>
      </Tooltip>
    </div>
  );
};

export default WorkspaceCardFooterField;
